import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { removeProductFromCart as apiRemoveProduct } from 'scripts/api/cart'
import emitter from 'scripts/utils/emitter'

import { useResize } from 'utils/hooks/use-resize'

import { Product } from 'checkout/components/MiniCart/Product'
import * as dataLayer from 'checkout/services/data-layer'

const Products = ({
  product,
  type,
  services,
  availableServices,
  regionId,
  productRemovalIsDisabled,
  updateProduct = () => {},
  removeProductFromCart = () => {}
}) => {
  const [animationKeys, setAnimationKeys] = useState({
    hideProduct: false,
    animation: false,
    showDisclaimer: false,
    hideComponent: false
  })
  const [isMobile] = useResize()

  const removeProductAPI = useCallback(async (product) => {
    await apiRemoveProduct(product?.id)
      .then(({ status }) => {
        dataLayer.removeFromCart({
          category: product.categoryTree,
          price: product.price?.to,
          productBrand: product.brand,
          productId: product.productId,
          productName: product.name,
          quantity: product.quantity,
          regionId: product.regionId
        })

        if (status === 204) {
          setAnimationKeys(keys => ({
            ...keys,
            animation: true
          }))

          setTimeout(() => {
            setAnimationKeys(keys => ({
              ...keys,
              hideProduct: true,
              animation: false,
              showDisclaimer: true
            }))
          }, 500)

          setTimeout(() => {
            setAnimationKeys(keys => ({
              ...keys,
              showDisclaimer: false,
              hideComponent: true
            }))

            removeProductFromCart({
              id: product?.id,
              updateTotal: true
            })
          }, 1500)
        }

        emitter.emit('cart:removed', {
          id: product?.id,
          uniqueProductsCount: 0
        })
      })
      .catch(err => {
        dataLayer.errorInMiniCartContext('clique_remover_item', 'Erro ao remover um item do carrinho')
        console.log('Error =>', err)
      })
  }, [removeProductFromCart])

  useEffect(() => {
    return () => {
      setAnimationKeys({
        hideProduct: false,
        animation: false,
        showDisclaimer: false,
        hideComponent: false
      })
    }
  }, [])

  if (animationKeys?.hideComponent) {
    return null
  }

  return (
    <Product
      animationKeys={animationKeys}
      key={product.id}
      isMobile={isMobile}
      product={{ ...product, type }}
      removeProduct={removeProductAPI}
      updateProduct={updateProduct}
      services={services}
      availableServices={availableServices}
      regionId={regionId}
      productRemovalIsDisabled={productRemovalIsDisabled}
    />
  )
}

Products.propTypes = {
  product: PropTypes.object,
  type: PropTypes.string,
  removeProductFromCart: PropTypes.func,
  updateProduct: PropTypes.func
}

export default Products
